// Arabic industry pages. The AR slugs are Arabic-friendly SEO URLs and
// intentionally differ from their English pairs — each entry declares its
// `enSlug` so hreflang points at the correct English translation via
// <Seo hreflangEn="..." />.

export const INDUSTRIES_AR = {
  "logistics-software-development-oman": {
    slug: "logistics-software-development-oman",
    enSlug: "logistics-transportation-in-oman",
    navLabel: "الخدمات اللوجستية والنقل",
    eyebrow: "الصناعات",
    h1: "تطوير برمجيات اللوجستيات في عُمان",
    meta: {
      title: "تطوير برمجيات اللوجستيات في عُمان",
      description: "الإرسال، تطبيقات السائقين، إدارة المستودعات، ونظام ERP اللوجستي — من شركة مقرها عُمان تبني منصتها الخاصة.",
    },
    intro: "نحن لا نكتفي ببناء برمجيات لوجستية. نحن نبني منصة لوجستية خاصة بنا — تطبيقات عملاء وسائقين، توزيع آلي، وبوابة أعمال للشركات الشاحنة، مصممة ومبنية ومُشغّلة بأنفسنا في عُمان.",
    sections: [
      {
        type: "bullets", heading: "ما يعاني منه هذا القطاع عادةً",
        items: [
          "تعيين السائقين عبر مكالمة هاتفية",
          "عملاء يتصلون ليسألوا أين طردهم",
          "إثبات التسليم على ورق",
          "أسعار تختلف لكل عميل وتعيش في رأس شخص",
          "لا فكرة عن الطرق الخاسرة",
        ],
      },
      {
        type: "grid", heading: "ما نبنيه للقطاع",
        items: [
          { title: "تطبيقات العملاء", desc: "الحجز، الدفع، التتبع، والتقييم." },
          { title: "تطبيقات السائقين", desc: "العروض، توجيه المسار، GPS، وإثبات التسليم." },
          { title: "محركات الإرسال", desc: "توزيع آلي مع تتابع وبديل عند الفشل." },
          { title: "بوابات الشاحنين", desc: "B2B، بأسعار تعاقدية، خدمة ذاتية." },
          { title: "إدارة المستودعات", desc: "من الاستلام إلى الإرسال، بدقة على مستوى الصندوق." },
          { title: "نظام ERP اللوجستي", desc: "العقود، الفوترة، والتقارير." },
        ],
      },
      { type: "callout", text: "الإثبات: منصتنا للتوصيل (عُمان، جاهزة للإطلاق)، نظام إدارة المستودعات (سنغافورة وماليزيا والولايات المتحدة، تم التسليم)، نظام ERP اللوجستي (الولايات المتحدة، تم التسليم)، ونظام جدولة الخدمة الميدانية (الولايات المتحدة، مباشر)." },
      { type: "bullets", heading: "القواعد والمعايير المطبّقة", items: ["قانون حماية البيانات العُماني", "لوائح المرور والنقل", "ضريبة القيمة المضافة والفوترة"] },
      {
        type: "faq",
        items: [
          { q: "هل يمكنكم تولّي نظام إرسال قائم؟", a: "نعم — بعد تدقيق عشرة أيام يعطيكم توصية صادقة: إصلاح / إعادة بناء." },
          { q: "كيف يتعامل التوزيع الآلي مع الإشارة الضعيفة؟", a: "العروض تتتابع مع مهلات زمنية، وترجع إلى التعيين اليدوي، وردود السائقين تُصفّ دون اتصال حتى تعود الإشارة." },
          { q: "علامة تجارية بيضاء لعملائكم الشاحنين؟", a: "نعم — كل شاحن على منصتنا يمكن أن يحمل علامته الخاصة وقائمة أسعاره." },
        ],
      },
    ],
    related: [
      { tag: "الحلول", label: "منصة التوصيل حسب الطلب", to: "/ar/solutions/on-demand-delivery-platform" },
      { tag: "الحلول", label: "الخدمات اللوجستية وإدارة الأساطيل", to: "/ar/solutions/logistics-fleet-software" },
      { tag: "الأعمال", label: "منصة التوصيل والخدمات اللوجستية", to: "/ar/work/delivery-logistics-platform" },
    ],
  },

  "ecommerce-software-development-oman": {
    slug: "ecommerce-software-development-oman",
    enSlug: "retail-e-commerce-in-oman",
    navLabel: "التجزئة والتجارة الإلكترونية",
    eyebrow: "الصناعات",
    h1: "تطوير برمجيات التجارة الإلكترونية في عُمان",
    meta: {
      title: "تطوير برمجيات التجارة الإلكترونية في عُمان",
      description: "المتجر هو الجزء السهل. نبني العمليات خلفه — المخزون، الطلبات، المرتجعات، وتكامل نقاط البيع.",
    },
    intro: "المتجر هو الجزء السهل. دقة المخزون، التوصيل، المرتجعات، تسوية المدفوعات، وخدمة العملاء هي ما يفشل فيه التجارة الإلكترونية فعليًا. نبني العمليات التي تجعل تشغيل تاجر إلكتروني مملًا — والملل هو ما تريدونه. منصة السوق الإلكترونية الخاصة بنا تدعم هذه القدرة.",
    sections: [
      {
        type: "grid", heading: "ما نبنيه للقطاع",
        items: [
          { title: "تجارة إلكترونية مخصصة", desc: "عندما لا تعود Shopify تناسبكم." },
          { title: "أسواق متعددة البائعين", desc: "البائعون، العمولات، والطلبات المُقسَّمة." },
          { title: "Shopify وHeadless", desc: "عندما تناسب — تُنفَّذ بشكل صحيح." },
          { title: "المخزون وإدارة الطلبات", desc: "رقم واحد للمخزون عبر القنوات." },
          { title: "الولاء", desc: "النقاط، المستويات، والاسترداد." },
          { title: "تكامل التوصيل ونقاط البيع", desc: "الأون لاين والمعرض على سجل واحد." },
        ],
      },
      { type: "callout", text: "قيد التطوير: منصة السوق الإلكترونية متعددة البائعين الخاصة بنا لسوق عُمان والخليج." },
      {
        type: "faq",
        items: [
          { q: "مخصص أم Shopify؟", a: "نوصي حسب موقعكم. Shopify ممتاز للمتاجر، والمخصص يفوز عندما تختلف عملياتكم عن المعتاد." },
          { q: "الانتقال من Magento أو WooCommerce؟", a: "نعم — العملاء، الطلبات، الكتالوج، والتاريخ محفوظون." },
          { q: "المدفوعات المحلية؟", a: "نعم — جميع بوابات الدفع العُمانية الكبرى، المحافظ، وBNPL حيث تناسب." },
        ],
      },
    ],
    related: [
      { tag: "الحلول", label: "منصة تجارة السوق الإلكترونية", to: "/ar/solutions/e-commerce-marketplace" },
      { tag: "الحلول", label: "إدارة المستودعات", to: "/ar/solutions/warehouse-management" },
      { tag: "الخدمات", label: "تصميم وتطوير الويب", to: "/ar/services/web-design-company-in-oman" },
    ],
  },

  "government-software-development-oman": {
    slug: "government-software-development-oman",
    enSlug: "government-public-sector-oman",
    navLabel: "القطاع الحكومي",
    eyebrow: "الصناعات",
    h1: "برمجيات القطاع الحكومي والعام في عُمان",
    meta: {
      title: "برمجيات القطاع الحكومي والعام في عُمان",
      description: "بوابات مواطنين ثنائية اللغة وقابلة للتدقيق، وأنظمة سير العمل. Meyar للحوكمة والأدلة.",
    },
    intro: "لماذا نناسب هذا القطاع: نحن شركة مقرها عُمان، نبني ثنائي اللغة كافتراض، و Meyar بُنيت خصيصًا لمتطلبات الحوكمة والأدلة التي تعمل ضمنها الجهات الحكومية. هذه الصفحة تصف ما نبنيه للقطاع — وليست ادعاءً بارتباطات قائمة.",
    sections: [
      {
        type: "grid", heading: "ما نبنيه للقطاع",
        items: [
          { title: "بوابات المواطنين", desc: "ثنائية اللغة، متاحة، وقابلة للتدقيق." },
          { title: "أنظمة سير العمل والموافقات", desc: "التفويض، التصعيد، والسجلات." },
          { title: "تطبيقات التفتيش الميدانية", desc: "تعمل دون اتصال، مع أدلة بالصور." },
          { title: "لوحات المعلومات", desc: "للمديرين ومكتب الوزير." },
          { title: "إدارة المستندات", desc: "التحكم بالإصدارات، الاحتفاظ، والإتلاف." },
          { title: "منصات الحوكمة", desc: "Meyar للحوكمة، المخاطر، والامتثال." },
          { title: "التكامل مع الأنظمة الحالية", desc: "أنظمة ERP قديمة، الهوية، والخدمات الوطنية." },
        ],
      },
      {
        type: "bullets", heading: "المعايير التي نبني عليها",
        items: [
          "قانون حماية البيانات العُماني (المرسوم 6/2022، القرار الوزاري 34/2024)",
          "متطلبات مركز الدفاع السيبراني (المرسوم 64/2020)",
          "ISO 27001",
          "معايير إتاحة WCAG",
          "دعم كامل للغة العربية",
        ],
      },
      {
        type: "faq",
        items: [
          { q: "هل تسلّمون لجهات حكومية اليوم؟", a: "هذه الصفحة تصف ما نبنيه للقطاع؛ ولا تدّعي ارتباطات قائمة. حيثما يناسب، يسعدنا شرح كيف يبدو بناء وفا في سياق قطاع عام." },
          { q: "هل يمكنكم التعامل مع متطلبات التصريح الأمني؟", a: "نعم لمهندسين مُرشَّحين." },
          { q: "المعالجة داخل البلاد؟", a: "أخبرونا في البداية ونصمم وفقها. إعادة توطين البيانات لاحقًا مكلفة." },
        ],
      },
    ],
    related: [
      { tag: "Meyar", label: "Meyar Enterprise GRC", to: "/ar/meyar/enterprise-grc" },
      { tag: "الخدمات", label: "برمجيات المؤسسات", to: "/ar/services/enterprise-software-development-company-in-oman" },
      { tag: "الخدمات", label: "الحوسبة السحابية وإقامة البيانات", to: "/ar/services/cloud-devops-oman" },
    ],
  },

  "fintech-software-development-oman": {
    slug: "fintech-software-development-oman",
    enSlug: "banking-financial-services-oman",
    navLabel: "الخدمات المصرفية والمالية",
    eyebrow: "الصناعات",
    h1: "برمجيات القطاع المصرفي والمالي",
    meta: {
      title: "برمجيات القطاع المصرفي والمالي في عُمان",
      description: "بوابات، تسجيل رقمي، اعرف عميلك، معالجة القروض، وإدارة المخاطر مبنية حول نواتكم المُنظَّمة.",
    },
    intro: "التسجيل الذي يستغرق أيامًا، أدلة الامتثال المبعثرة بين الأقسام، وأنظمة تواجه العملاء تبدو كأنها من عقد مضى — هذه هي المشاكل التي نبني من أجلها في هذا القطاع. نبني حول نواتكم المُنظَّمة؛ لا نستبدلها. هذه الصفحة تصف القدرة والملاءمة، لا ارتباطات قائمة.",
    sections: [
      {
        type: "bullets", heading: "ما يعاني منه هذا القطاع عادةً",
        items: [
          "تسجيل يستغرق أيامًا",
          "أدلة امتثال مبعثرة بين الأقسام",
          "أنظمة تواجه العملاء تبدو من عقد مضى",
        ],
      },
      {
        type: "grid", heading: "ما نبنيه للقطاع",
        items: [
          { title: "بوابات العملاء", desc: "حديثة، الجوال أولًا، ثنائية اللغة." },
          { title: "التسجيل الرقمي واعرف عميلك", desc: "المستندات، الحيوية، والفحص." },
          { title: "معالجة القروض", desc: "من الطلب إلى الصرف، مع تدقيق في كل خطوة." },
          { title: "المخاطر والامتثال", desc: "Meyar لمخاطر وضوابط المؤسسة." },
          { title: "التقارير والتسويات", desc: "المنظم، مجلس الإدارة، والعمليات اليومية على نفس الأرقام." },
          { title: "تكامل النواة المصرفية", desc: "حول نواتكم المُنظَّمة — لا استبدالها." },
        ],
      },
      { type: "callout", text: "نبني حول نواتكم المصرفية المُنظَّمة، لا نستبدلها." },
      {
        type: "faq",
        items: [
          { q: "هل تبنون أنظمة نواة مصرفية؟", a: "لا. نبني الطبقات التي تواجه العملاء والمخاطر حولها." },
          { q: "هل تعملون مع أشكال تقارير البنك المركزي العُماني؟", a: "نعم — Meyar ووحدات التقارير المخصصة لدينا تُولّد النماذج المطلوبة وتُقدّمها في مواعيدها." },
          { q: "مراقبة على نمط مركز عمليات الأمن؟", a: "Meyar تحكم ضوابط الأمن لديكم لكنها ليست منصة مراقبة. المراقبة نفسها يقوم بها مركز عمليات الأمن لديكم أو مزوّد خدمات الأمن المُدارة." },
          { q: "هل تسلّمون للبنوك اليوم؟", a: "هذه الصفحة تصف ما نبنيه للقطاع؛ ولا تدّعي ارتباطات قائمة." },
        ],
      },
    ],
    related: [
      { tag: "Meyar", label: "Meyar Enterprise GRC", to: "/ar/meyar/enterprise-grc" },
      { tag: "Meyar", label: "Meyar Cyber Security GRC", to: "/ar/meyar/cyber-security-grc" },
      { tag: "الخدمات", label: "برمجيات المؤسسات", to: "/ar/services/enterprise-software-development-company-in-oman" },
    ],
  },

  "healthcare-software-development-oman": {
    slug: "healthcare-software-development-oman",
    enSlug: "healthcare-in-oman",
    navLabel: "الرعاية الصحية",
    eyebrow: "الصناعات",
    h1: "برمجيات القطاع الصحي في عُمان",
    meta: {
      title: "برمجيات القطاع الصحي في عُمان",
      description: "إدارة العيادات والمستشفيات، بوابات المرضى، والطب عن بُعد — مصممة وفق قواعد البيانات الشخصية الحساسة في قانون حماية البيانات.",
    },
    intro: "المعلومات الصحية بيانات شخصية حساسة بموجب قانون حماية البيانات، ومعالجتها خارج عُمان تستوجب موافقة الوزارة. نرسم ذلك معكم قبل كتابة أي كود، ليكون القرار واعيًا وموثقًا. هذه الصفحة تصف ما نبنيه للقطاع، لا ارتباطات قائمة.",
    sections: [
      {
        type: "grid", heading: "ما نبنيه للقطاع",
        items: [
          { title: "إدارة العيادات والمستشفيات", desc: "المرضى، المواعيد، السجلات الطبية، الفواتير." },
          { title: "المواعيد والتذكيرات", desc: "ثنائية اللغة، عبر الرسائل النصية وواتساب." },
          { title: "بوابات المرضى", desc: "خدمة ذاتية للسجلات والنتائج." },
          { title: "CRM للرعاية الصحية", desc: "من الاستفسار إلى الاستشارة إلى المتابعة." },
          { title: "الطب عن بُعد", desc: "الاستشارات، السجلات، والوصفات." },
          { title: "الصيدلية والمخزون", desc: "المخزون، الدفعات، انتهاء الصلاحية، والصرف." },
          { title: "مطالبات التأمين", desc: "الأكواد، التسوية، والتتبع." },
        ],
      },
      {
        type: "faq",
        items: [
          { q: "قانون حماية البيانات والبيانات الصحية الحساسة؟", a: "المعلومات الصحية فئة حساسة بموجب القانون. معالجتها خارج عُمان تستوجب موافقة الوزارة — نصمم تدفق البيانات ليكون هذا القرار واعيًا." },
          { q: "هل تتكاملون مع أنظمة معلومات المستشفيات الحالية؟", a: "نعم — HL7، FHIR، وواجهات مزوّدين محددة. نبني الوحدة التي تحتاجونها دون استبدال النظام الأساسي." },
          { q: "تكامل مع لوائح التأمين؟", a: "نعم، ملفات مطالبات خاصة بكل لائحة وفحص الأهلية." },
          { q: "هل تسلّمون لمزوّدي الرعاية الصحية اليوم؟", a: "هذه الصفحة تصف ما نبنيه للقطاع؛ ولا تدّعي ارتباطات قائمة." },
        ],
      },
    ],
    related: [
      { tag: "الخدمات", label: "تطوير برمجيات مخصصة", to: "/ar/services/custom-software-development-company-in-oman" },
      { tag: "الخدمات", label: "تطوير تطبيقات الجوال", to: "/ar/services/mobile-app-development-company-in-oman" },
      { tag: "الخدمات", label: "الحوسبة السحابية وإقامة البيانات", to: "/ar/services/cloud-devops-oman" },
    ],
  },

  "real-estate-software-development-oman": {
    slug: "real-estate-software-development-oman",
    enSlug: "real-estate-facilities-oman",
    navLabel: "العقارات والمرافق",
    eyebrow: "الصناعات",
    h1: "برمجيات العقارات والمرافق",
    meta: {
      title: "برمجيات العقارات والمرافق في عُمان",
      description: "CRM عقاري، تطبيقات المجتمعات والمباني، وإدارة المرافق.",
    },
    intro: "العقار قطاع بيانات في ثوب قطاع طوب وأسمنت. هذه الصفحة تصف ما نبنيه للقطاع، مؤطّرًا حول ما صُممت له منصاتنا — لا قائمة بارتباطات قائمة.",
    sections: [
      {
        type: "grid", heading: "ما نبنيه للقطاع",
        items: [
          { title: "بوابات القوائم", desc: "البحث، المعاينات، والاستفسارات." },
          { title: "CRM عقاري", desc: "تقييم العملاء، إدارة المعاينات، والمفاوضات." },
          { title: "تطبيقات المجتمع والمباني", desc: "الدخول، الزوار، الصيانة، والمدفوعات." },
          { title: "المرافق وأوامر العمل", desc: "الطلبات، الإرسال، والصيانة الوقائية." },
          { title: "بوابات المستأجرين والمُلاك", desc: "كشوف الحسابات، الطلبات، والمراسلات." },
          { title: "إدارة مبيعات المطوّرين", desc: "الوحدات، المجمعات، العقود، والتسليم." },
        ],
      },
      {
        type: "faq",
        items: [
          { q: "هل يمكنه التكامل مع المحاسبة لدينا؟", a: "نعم — Tally، Zoho Books، QuickBooks، وأنظمة مالية مخصصة." },
          { q: "أجهزة التحكم بالدخول؟", a: "نتكامل مع أجهزة التحكم الشائعة عبر واجهاتها البرمجية." },
          { q: "تحصيل المدفوعات؟", a: "نعم — متكررة ولمرة واحدة، عبر بوابات الدفع المحلية." },
        ],
      },
    ],
    related: [
      { tag: "الحلول", label: "تطبيق المجتمع والمباني", to: "/ar/solutions/community-building-app" },
      { tag: "الخدمات", label: "تطوير CRM", to: "/ar/services/crm-software-development-company-in-oman" },
      { tag: "الخدمات", label: "تطوير تطبيقات الجوال", to: "/ar/services/mobile-app-development-company-in-oman" },
    ],
  },

  "education-software-development-oman": {
    slug: "education-software-development-oman",
    enSlug: "education-in-oman",
    navLabel: "التعليم",
    eyebrow: "الصناعات",
    h1: "برمجيات القطاع التعليمي",
    meta: {
      title: "برمجيات القطاع التعليمي في عُمان",
      description: "إدارة المدارس، نظم إدارة التعلم، CRM القبول، تطبيقات أولياء الأمور، وإدارة الرسوم.",
    },
    intro: "المؤسسات التعليمية تحمل بيانات حساسة أكثر من معظم البنوك — سجلات القاصرين، معلومات صحية، وترتيبات مالية. هذه الصفحة تصف ما نبنيه للقطاع؛ ولا تدّعي ارتباطات قائمة.",
    sections: [
      {
        type: "grid", heading: "ما نبنيه للقطاع",
        items: [
          { title: "إدارة المدارس والمعاهد", desc: "الطلاب، الموظفون، الفصول، والسجلات." },
          { title: "نظام إدارة التعلم", desc: "المقررات، التقييمات، ومكتبة المحتوى." },
          { title: "CRM القبول", desc: "من الاستفسار إلى التسجيل، في مسار واحد." },
          { title: "تطبيقات أولياء الأمور والطلاب", desc: "المراسلات، الحضور، والدرجات." },
          { title: "إدارة الرسوم", desc: "الفواتير، التحصيل، والتذكيرات." },
          { title: "الحضور والجداول", desc: "حسب الفصل، الطالب، والمعلم." },
          { title: "الاختبارات والنتائج", desc: "من التصحيح إلى الشهادات." },
        ],
      },
      {
        type: "faq",
        items: [
          { q: "ثنائي اللغة؟", a: "نعم — عربي وإنجليزي، جنبًا إلى جنب أو مُبدَّل حسب المستخدم." },
          { q: "التكاملات؟", a: "أنظمة معلومات الطلاب، نظم إدارة التعلم، المحاسبة، بوابات الرسائل، والبوابات الحكومية." },
          { q: "خصوصية القاصرين؟", a: "قانون حماية البيانات يشمل بيانات الأطفال. نتعامل معها وفقًا لذلك ونصمم تدفقات موافقة لأولياء الأمور." },
        ],
      },
    ],
    related: [
      { tag: "الخدمات", label: "تطوير تطبيقات الجوال", to: "/ar/services/mobile-app-development-company-in-oman" },
      { tag: "الخدمات", label: "تطوير CRM", to: "/ar/services/crm-software-development-company-in-oman" },
      { tag: "الخدمات", label: "تطوير برمجيات مخصصة", to: "/ar/services/custom-software-development-company-in-oman" },
    ],
  },

  "manufacturing-software-development-oman": {
    slug: "manufacturing-software-development-oman",
    enSlug: "manufacturing-distribution-oman",
    navLabel: "الصناعة والتوزيع",
    eyebrow: "الصناعات",
    h1: "برمجيات التصنيع والتوزيع",
    meta: {
      title: "برمجيات التصنيع والتوزيع في عُمان",
      description: "تخطيط الإنتاج، الجودة، الصيانة، وبوابات الموزّعين — مترابطة حول رقم المنتج.",
    },
    intro: "الإنتاج، الجودة، الصيانة، والمبيعات جميعها تنتمي إلى نفس السجل — لأن هذا السجل في التصنيع هو المنتج المتحرك عبر عملكم. هذه الصفحة تصف ما نبنيه للقطاع؛ ولا تدّعي ارتباطات قائمة.",
    sections: [
      {
        type: "grid", heading: "ما نبنيه للقطاع",
        items: [
          { title: "تخطيط الإنتاج", desc: "الأوامر، قوائم المواد، الطاقة، والتسلسل." },
          { title: "المخزون والمواد الخام", desc: "حسب الموقع، الدفعة، وانتهاء الصلاحية." },
          { title: "إدارة الجودة", desc: "الفحوصات، عدم المطابقة، والإجراءات التصحيحية." },
          { title: "جدولة الصيانة", desc: "الوقائية والانهيار، مع تتبع التكاليف." },
          { title: "بوابات الموزّعين والوكلاء", desc: "الطلبات، الائتمان، والمرتجعات." },
          { title: "إدارة المسارات", desc: "المبيعات المتنقلة والطلب المسبق." },
          { title: "إدارة المستودعات", desc: "من الاستلام إلى الإرسال، بدقة على مستوى الصندوق." },
        ],
      },
      {
        type: "faq",
        items: [
          { q: "التكامل مع نظام ERP لدينا؟", a: "نعم — SAP، Oracle، Odoo، ومخصصة. نبني الوحدة الخاصة بعملياتكم دون استبدال النواة." },
          { q: "الباركود و RFID؟", a: "الاثنان — الاختيار يعتمد على سير عملكم وكثافة مخزونكم." },
        ],
      },
    ],
    related: [
      { tag: "الحلول", label: "إدارة المستودعات", to: "/ar/solutions/warehouse-management" },
      { tag: "الخدمات", label: "ERP و HRMS", to: "/ar/services/erp-software-development-company-in-oman" },
      { tag: "الخدمات", label: "برمجيات المؤسسات", to: "/ar/services/enterprise-software-development-company-in-oman" },
    ],
  },

  "automotive-software-development-oman": {
    slug: "automotive-software-development-oman",
    enSlug: "automotive-in-oman",
    navLabel: "السيارات",
    eyebrow: "الصناعات",
    h1: "برمجيات القطاع السيّارات",
    meta: {
      title: "برمجيات قطاع السيارات في عُمان",
      description: "إدارة المعارض، القوائم العامة، حجز الخدمة والورش، مخزون قطع الغيار، وتكامل التمويل.",
    },
    intro: "المركبة هي السجل. المبيعات، الخدمة، القطع، والتمويل ينبغي أن ترتبط جميعها حول رقم الشاسيه — لا حول القسم الذي يملك الدفاتر. منصتنا لإدارة المعارض مباشرة في مسقط.",
    sections: [
      { type: "callout", text: "الإثبات: منصتنا لإدارة المعارض مباشرة في مسقط — مخزون المركبات بما في ذلك مخزون الأمانة، المبيعات، العملاء المحتملون، الحجوزات، المدفوعات، المستندات، تصريح البيع القابل للطباعة، وإفراج الفحص ونماذج القيادة التجريبية، التقارير، بالإضافة إلى موقع قوائم عام." },
      {
        type: "grid", heading: "ما نبنيه للقطاع",
        items: [
          { title: "المعارض والوكالات", desc: "المخزون (المملوك والأمانة)، المبيعات، العملاء المحتملون." },
          { title: "مواقع القوائم العامة", desc: "بحث واستفسارات تواجه المستهلك." },
          { title: "CRM للسيارات", desc: "من الاستفسار إلى البيع إلى الخدمة إلى البيعة التالية." },
          { title: "حجز الخدمة والورش", desc: "المواقع، الفنيون، المهام، والفوترة." },
          { title: "مخزون قطع الغيار", desc: "حسب رقم الشاسيه ورقم القطعة." },
          { title: "تكامل التمويل", desc: "واجهات البنوك وشركات التمويل حيث تتوفر." },
        ],
      },
      {
        type: "faq",
        items: [
          { q: "مركبات الأمانة؟", a: "نعم — ملكية منفصلة، هيكل عمولات، وتتبع صرف." },
          { q: "النماذج القابلة للطباعة؟", a: "نعم — تصريح البيع، إفراج الفحص، القيادة التجريبية، جميعها A4 وجاهزة بالعربية." },
        ],
      },
    ],
    related: [
      { tag: "الحلول", label: "إدارة المعارض", to: "/ar/solutions/showroom-management" },
      { tag: "الخدمات", label: "تطوير CRM", to: "/ar/services/crm-software-development-company-in-oman" },
      { tag: "الأعمال", label: "منصة إدارة المعارض", to: "/ar/work/showroom-management-platform" },
    ],
  },
};
